"use client";

function PageTransition({ children }) {
    return children;
}

export default PageTransition;
